import React from 'react';
import ResCopyClipboard from '../../containers/Reservation/component/res-copy-clipboard';
import { COPY_TO_CLIPBOARD } from '../../shared/AppImages';
import ImageIcon from '../UI/icon/image-icon';

function GeneralCard(props) {
    const { title, value, apiData } = props;
    return (
        <div className='item-card-container'>
            {apiData?.mainIcon &&
                <ImageIcon
                    img={apiData?.mainIcon?.imgSrc}
                    mainClass={apiData?.mainIcon?.mainClass}
                    iconClass={apiData?.mainIcon?.iconClass}
                    title={apiData?.mainIcon?.title} />
            }
            <div className='main-card'>
                <label className='general-card-name'>{title}</label>
                {
                    value && apiData?.isCopyToClipBoard ?
                        <div className='card-value-container'>
                            <label className='item-card-value'>{value || "--"}</label>
                            {value && <ResCopyClipboard value={value}>
                                <img
                                    src={COPY_TO_CLIPBOARD}
                                    alt={value}
                                    onClick={apiData?.onClick}
                                    title='Copy to clipboard'
                                />
                            </ResCopyClipboard>}
                        </div>
                        : value && apiData?.onClick ?
                            <div className='card-value-container'>
                                <label className='item-card-value'>{value}</label>
                                <img
                                    src={apiData?.icon}
                                    alt={value}
                                    onClick={apiData?.onClick}
                                />
                            </div>
                            : <label className='item-card-value'>{value || "--"}</label>
                }
            </div>
        </div>
    )
}

export default GeneralCard